/* eslint-disable no-console */
import { Auth } from 'aws-amplify';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import './logout.scss';
import PrimaryButton from '../../../shared/buttons/primary-button/primary-button';
import GlobalError from '../../../shared/blocks/global-error/global-error';
import Loader from '../../../shared/blocks/loader/loader';
import clearLocalIndexedDb from '../../../../utilities/clearIndexDb';

const Logout = () => {
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();

  const queryParams = new URLSearchParams(window.location.search);
  const redirect = queryParams?.get('uri');

  const ContinueShopping = () => {
    if (redirect) {
      window.location.replace(redirect);
    } else {
      window.location.replace('/');
    }
  };

  const signout = async () => {
    try {
      await Auth.signOut();
      dispatch({ type: 'accounts/setCustomerId', payload: null });
      localStorage.removeItem('access_token');
      localStorage.removeItem('id_token');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('anonymousId');
      clearLocalIndexedDb();
      dispatch({ type: 'accounts/setCustomerId', payload: false });
    } catch (error) {
      const globalError = document.querySelector('.global-error-box');
      globalError?.classList.remove('d-none');
    }
    window.pubSub?.publish('onAccountSignOut', {});
    setIsLoading(false);
  };

  useEffect(() => {
    try {
      window.pubSub?.publish(
        'onCartUpdate', { lineItems: [] },
      );
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    }
    signout();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="logout-page d-flex-center flex-column">
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <div>
            <h4 className="logout-header c-purple fs-h4 ff-wallop">
              You&apos;ve Been Signed Out
            </h4>
          </div>
          <GlobalError />
          <div className="d-flex-center flex-column">
            <div className="fs-p1 m-b-xs c-midnight ff-graphik">
              You have been signed out of your Purple account.
            </div>
            <PrimaryButton
              onClick={ContinueShopping}
              title="Continue Shopping"
              isLoading={false}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default Logout;
